import React from "react";
// import { SiloType } from "@components/common/ddr/ddrTypes";
import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "@utils/utils";
import { DDRContext } from "@services/providers/DDRProvider";

const imageVariants = cva("cursor-pointer", {
  variants: {
    variant: {
      image: "object-contain",
      icon: "w-8 h-8 rounded-md border p-1 object-contain inline-block",
      rounded: "rounded-full border object-contain",
      path: "",
      custom: "",
    },
    size: {
      small: "w-10 h-10",
      medium: "w-14 h-14",
      large: "w-20 h-20",
    },
  },
  compoundVariants: [
    {
      variant: "icon",
      size: "medium",
      class: "w-8 h-8",
    },
  ],
  defaultVariants: {
    variant: "image",
    size: "medium",
  },
});
interface SiloImageProps extends VariantProps<typeof imageVariants> {
  type: string;
  className?: string;
  tooltip?: string;
}

const useLogos = () => {
  const { pluginLogos } = React.useContext(DDRContext);
  return { pluginLogos };
};

const SiloImage: React.FC<SiloImageProps> = ({
  type,
  variant = "image",
  size = "medium",
  className,
  tooltip,
}) => {
  const { pluginLogos } = useLogos();
  // const SiloImages: Record<SiloType, string> = {
  //   [SiloType.AZURE]: process.env.STATIC_PATH + "/images/azure_logo.png",
  //   [SiloType.AWS_S3]: process.env.STATIC_PATH + "/images/amazon_s3.png",
  //   [SiloType.AWS_IAM]: process.env.STATIC_PATH + "/images/aws_iam.png",
  //   [SiloType.AZURE_STORAGE]:
  //     process.env.STATIC_PATH + "/images/azure_logo.png",
  //   [SiloType.AZURE_EMAIL]:
  //     process.env.STATIC_PATH + "/images/microsoft_logo.png",
  //   [SiloType.AZURE_BLOB]: process.env.STATIC_PATH + "/images/google_cloud.png",
  //   [SiloType.AZURE_ONE_DRIVE]:
  //     process.env.STATIC_PATH + "/images/onedrive_logo.png",
  //   [SiloType.ALIBABA_OSS]:
  //     process.env.STATIC_PATH + "/images/alibaba_logo.png",
  //   [SiloType.GOOGLE_BUCKET]:
  //     process.env.STATIC_PATH + "/images/onedrive_logo.png",
  //   [SiloType.GOOGLE_CLOUD]:
  //     process.env.STATIC_PATH + "/images/google_cloud.png",
  //   [SiloType.GOOGLE_DRIVE]:
  //     process.env.STATIC_PATH + "/images/google_drive_logo.png",
  //   [SiloType.GOOGLE_STORAGE]:
  //     process.env.STATIC_PATH + "/images/google_drive_logo.png",
  //   [SiloType.SALES_FORCE_STORE]:
  //     process.env.STATIC_PATH + "/images/google_cloud.png",
  //   [SiloType.NETSUITE_STORE]:
  //     process.env.STATIC_PATH + "/images/netsuite_logo.png",
  //   [SiloType.DROPBOX_STORE]:
  //     process.env.STATIC_PATH + "/images/dropbox_logo.png",
  //   [SiloType.LOG_MGMT_FTP]: process.env.STATIC_PATH + "/images/ftp_logo.png",
  //   [SiloType.LOG_MGMT_SMB]: process.env.STATIC_PATH + "/images/smb_logo.png",
  //   [SiloType.LOG_MGMT_SFTP]: process.env.STATIC_PATH + "/images/sftp_logo.png",
  //   [SiloType.ACTIVE_DIRECTORY]:
  //     process.env.STATIC_PATH + "/images/active_directory_logo.png",
  //   [SiloType.MSSQL]: process.env.STATIC_PATH + "/images/mssql_logo.png",
  //   [SiloType.MYSQL]: process.env.STATIC_PATH + "/images/mysql_logo.png",
  //   [SiloType.ORACLE]: process.env.STATIC_PATH + "/images/oracle_logo.png",
  //   [SiloType.POSTGRES]:
  //     process.env.STATIC_PATH + "/images/postgresql_logo.png",
  //   [SiloType.MONGO]: process.env.STATIC_PATH + "/images/mongo_logo.png",
  //   [SiloType.TEAMS]: process.env.STATIC_PATH + "/images/teams_logo.png",
  //   [SiloType.AZURE_SHAREPOINT]:
  //     process.env.STATIC_PATH + "/images/azure_sharepoint.png",
  //   [SiloType.MICROSOFT_TEAMS]: process.env.STATIC_PATH + "/images/teams.png",

  //   [SiloType.GITHUB]: process.env.STATIC_PATH + "/images/github_logo.png",
  //   [SiloType.ORACLE_CLOUD]:
  //     process.env.STATIC_PATH + "/images/oracle_cloud_logo.png",
  //   [SiloType.SNOWFLAKE]:
  //     process.env.STATIC_PATH + "/images/snowflake_logo.png",
  //   [SiloType.AZURE_SQL]: process.env.STATIC_PATH + "/images/sql_database.png",
  //   [SiloType.ORACLE_WAREHOUSE]:
  //     process.env.STATIC_PATH + "/images/oracle_logo.png",
  //   [SiloType.MARIA_DB]: process.env.STATIC_PATH + "/images/mariadb_logo.png",
  //   [SiloType.AWS_RDS_MYSQL]:
  //     process.env.STATIC_PATH + "/images/aws_rds_logo.png",
  //   [SiloType.AWS_RDS_MSSQL]:
  //     process.env.STATIC_PATH + "/images/aws_rds_logo.png",
  //   [SiloType.AWS_RDS_POSTGRESQL]:
  //     process.env.STATIC_PATH + "/images/aws_rds_logo.png",
  //   [SiloType.AWS_RDS_ORACLE]:
  //     process.env.STATIC_PATH + "/images/aws_rds_logo.png",
  //   [SiloType.AWS_RDS_MARIADB]:
  //     process.env.STATIC_PATH + "/images/aws_rds_logo.png",
  //   [SiloType.AWS_RDS_IBM_DB2]:
  //     process.env.STATIC_PATH + "/images/aws_rds_logo.png",
  //   [SiloType.JIRA]: process.env.STATIC_PATH + "/images/jira_logo.png",
  //   [SiloType.ZOOM]: process.env.STATIC_PATH + "/images/zoom_logo.png",
  //   [SiloType.slack]: process.env.STATIC_PATH + "/images/slack_logo.png",
  //   [SiloType.copilot]: process.env.STATIC_PATH + "/images/copilot_logo.png",
  // };

  // let imgPath = SiloImages[type];
  let imgPath = "/static/ls/images/plugin-default.jpg";

  if (pluginLogos && pluginLogos[type] && pluginLogos[type].logo_src) {
    imgPath = pluginLogos[type].logo_src;
  }
  if (variant == "path") {
    return imgPath;
  }
  return (
    <img
      src={imgPath}
      alt={`${type} logo`}
      title={tooltip ?? type}
      onError={(e) => {
        const target = e.currentTarget as HTMLImageElement;
        target.onerror = null;
        target.src = "/static/ls/images/plugin-default.jpg";
      }}
      className={cn(`${imageVariants({ variant, size, className })}`)}
    />
  );
};

export default SiloImage;
